import { RDSChatroom as RDSChatroomComponent } from "@relay/rds/dist/index";
import React from "react";

interface Props {
  token: string;
  currentUserName: string;
  chatroomKey: string;
  canReview: boolean;
  inGodMode: boolean;
  isCompact: boolean;
  language: "en" | "es" | "original" | "translate";
  readOnlyMode?: boolean;
}

const RDSChatroom: React.FunctionComponent<Props> = (props: Props) => {
  return <RDSChatroomComponent {...props} />;
};

export default RDSChatroom;
